// import external dependencies
import 'jquery';
import 'ekko-lightbox/dist/ekko-lightbox.js';
import ScrollReveal from 'scrollreveal'

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faAngleDown, faBars, faChevronDown, faSquareFull } from '@fortawesome/free-solid-svg-icons';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';

// add the imported icons to the library
library.add(faAngleDown, faSquareFull, faBars, faFacebookSquare, faInstagram, faChevronDown);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Load some Google Fonts asynchrously 
// Typekit Web Font Loader https://github.com/typekit/webfontloader// https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js loads latest 1.x version
window.WebFontConfig = {  google: { families: [ 'Merriweather+Sans:300,500,700', 'Oswald:400,700' ] }};
(function() {  var wf = document.createElement('script');  
wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';  
wf.type = 'text/javascript';  wf.async = 'true';  
var s = document.getElementsByTagName('script')[0];  
s.parentNode.insertBefore(wf, s);
})();

jQuery(document).ready(function($) {
  $(window).on('scroll touchmove', function () {
    $('header').toggleClass('on-move', $(document).scrollTop() > 90);
  });

  if($(document).scrollTop() > 0 && !$('.site-header').hasClass('on-move') ){
    $('.site-header').toggleClass('on-move', $(document).scrollTop() > 90);
  }

  $('a[href]').filter(function() {
    return /(jpg|gif|png)$/.test( $(this).attr('href'))
  }).attr({'data-toggle': 'lightbox', 'data-gallery': 'gallery'});

  $(document).on('click', '[data-toggle="lightbox"], .widget_media_image a', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
  });

  // Ostoskorin update cart toiminto
  $('div.woocommerce').on('click', 'button[name="update_cart"], a.remove', function(){
    if( $('.badge-cart-count').length ) {
      var checkout_cart_count = parseInt(0);

      $('input.qty').each(function(index, el) {
        checkout_cart_count = Number(checkout_cart_count) + Number($(el).val());
      });

      $('.badge-cart-count').fadeOut('400', function() {
        if( checkout_cart_count != 0 ) {
          $('.badge-cart-count').text(checkout_cart_count).fadeIn('400');
        }
      });
    }
  });

  $('.product').on('click', 'a.ajax_add_to_cart', function(){
    if( $('.badge-cart-count').length ) {
      var checkout_cart_count_prod = Number( $('.badge-cart-count').first().text() ) + 1;
      
      $('.badge-cart-count').fadeOut('400', function() {
        $(this).text(checkout_cart_count_prod).fadeIn('400');
      });
    } else {
      setTimeout(function(){ location.reload(); }, 1500);
    }
  });

  $('.scroll-to-content').click(function(event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $('.page-content').offset().top - 75,
    }, 1000);
  });

  var sr = ScrollReveal({
    scale: 1,
    distance: '50px',
    delay: 100,
  });
  sr.reveal('.lifts');
  sr.reveal('.blocks-gallery-item');
});




// WEBPACK FOOTER //
// ./scripts/main.js